import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User, RequestGeneral } from '@app/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() user: User;
  @Output() profile = new EventEmitter<number>();
  @Output() logout = new EventEmitter();
  @Output() sidenav = new EventEmitter();
  @Input() requests: RequestGeneral[];
  @Output() SelectRequestEvent = new EventEmitter<RequestGeneral>();

  myControl: FormControl = new FormControl();


  filteredOptions: Observable<RequestGeneral[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filter(val))
      );
  }

  filter(val: string): RequestGeneral[] {
    if (val.length > 1) {
      return this.requests.filter(request =>
        request.requestNumber.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
  }

  onProfile(id: number) {
    this.profile.emit(id)
  }

  onLogout() {
    this.logout.emit()
  }

  onSideNavToggle() {
    this.sidenav.emit()
  }

  displayFn(request?: RequestGeneral): string | undefined {
    return request ? request.requestNumber : undefined;
  }

  onSearchComplete(event) {
    if (event.keyCode == 13) {
      //alert(this.myControl.value ? this.myControl.value.requestId : '0');
      if (this.myControl.value && this.myControl.value.requestId > 0) {
        this.onSelectRequest(this.myControl.value)
      }
    }
  }

 
  onSelectRequest(request: RequestGeneral) {
    this.SelectRequestEvent.emit(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/toolbar/toolbar.component.ts